import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';

import { BrowserModule } from '@angular/platform-browser';

import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
} from '@angular/common/http';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// ======================================================
// Routing
// ======================================================

import { AppRoutingModule } from './app-routing-module';

// ======================================================
// App
// ======================================================

import { App } from './app';

// ======================================================
// Interceptors
// ======================================================

import { authTokenInterceptor } from './core/interceptors/auth-token.interceptor';

import { unauthorizedInterceptor } from './core/interceptors/unauthorized.interceptor';

import { LoadingInterceptor } from './core/interceptors/loading.interceptor';

// ======================================================
// Layouts
// ======================================================

import { PublicLayoutComponent } from './layouts/public-layout/public-layout.component';

import { MemberLayoutComponent } from './layouts/member-layout/member-layout.component';

// ======================================================
// Public Views
// ======================================================

import { HomeComponent } from './views/home/home.component';

import { LoginComponent } from './views/login/login.component';

import { RegisterComponent } from './views/register/register.component';

// ======================================================
// Member Views
// ======================================================

import { DashboardComponent } from './views/member/dashboard/dashboard.component';

import { ProjectCreateComponent } from './views/member/createproject/project-create';

import { ProjectListComponent } from './views/member/projectlist/projectlist.component';

import { Settings } from './views/member/settings/settings';

import { Userprofile } from './views/member/userprofile/userprofile';


import { MarketComponent } from './views/market/market.component';
import { ApplicationProfileComponent } from './views/application-profile/application-profile.component';
import { PublicFooterLayoutComponent } from './layouts/public-footer-layout/public-footer-layout.component';
import { MarketPlaceComponent } from './views/member/marketplace/marketplace.component';
import { DashboardCompany } from './views/member/dashboard-company/dashboard-company';
import { DashboardLoader } from './views/member/dashboard-loader/dashboard-loader';
import { DashboardError } from './views/member/dashboard-error/dashboard-error';
import { ProjectInfo } from './views/member/project-info/project-info';
import { ProjectRun } from './views/member/project-run/project-run';
import { CommonModule } from '@angular/common';

@NgModule({
  // ====================================================
  // Components
  // ====================================================

  declarations: [
    App,

    // Layouts

    // Public
    HomeComponent,
    LoginComponent,
    RegisterComponent,

    // Member
    DashboardComponent,
    ProjectCreateComponent,
    ProjectListComponent,
    Settings,
    Userprofile,
    ApplicationProfileComponent,
    MarketPlaceComponent,
    DashboardCompany,
    DashboardError,
    ProjectInfo,
    ProjectRun,
  ],

  // ====================================================
  // Modules
  // ====================================================

  imports: [
    CommonModule,
    BrowserModule,
    ReactiveFormsModule,
    FormsModule,
    AppRoutingModule,
    DashboardLoader,
  ],

  // ====================================================
  // Providers
  // ====================================================

  providers: [
    provideBrowserGlobalErrorListeners(),

    // --------------------------------------------------
    // Class / DI Interceptors
    // --------------------------------------------------

    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true,
    },

    // --------------------------------------------------
    // HttpClient
    // --------------------------------------------------

    provideHttpClient(
      // Functional interceptors
      withInterceptors([authTokenInterceptor, unauthorizedInterceptor]),

      // HTTP_INTERCEPTORS ile tanımlanan
      // class interceptor'ları da çalıştırır.
      withInterceptorsFromDi(),
    ),
  ],

  // ====================================================
  // Schemas
  // ====================================================

  schemas: [CUSTOM_ELEMENTS_SCHEMA],

  // ====================================================
  // Bootstrap
  // ====================================================

  bootstrap: [App],
})
export class AppModule {}
